<template>
    <v-container>
        <v-card v-if="!users">
            <v-card-title v-if="org" class="display-1 font-weight-light">
                <v-btn class="" icon @click="save()" v-if="dirty" color="primary">
                    <v-icon large>
                        {{icons.savealt}}
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text v-if="!appdata">
                <h3>Fetch Data</h3>
                <v-progress-linear indeterminate ></v-progress-linear>
            </v-card-text>
            <v-card-text v-else>
                <v-form ref="form" v-model="validinfo" v-if="info">
                    <v-row >
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="App/Organization Name"
                                    v-model="info.fullname"
                                    clearable
                                    outlined
                                    :rules="[$store.state.rules.required]"
                                    hint="Required - Can be changed at any time"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="Phone"
                                    v-model="info.phone"
                                    clearable
                                    :rules="[$store.state.rules.cellRules]"
                                    outlined
                                    type="number"
                                    :counter="10"
                                    hint="a cell number "
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="Email"
                                    v-model="info.email"
                                    clearable
                                    :rules="[$store.state.rules.emailRules]"
                                    outlined
                                    :append-outer-icon="info.emailverified?$store.state.icons.thumbsup:$store.state.icons.question"
                                    @click:append-outer="verifyEmail($event)"
                                    hint="the email you wish to use to send from (can be different or same than your login)"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="Address line 1"
                                    v-model="info.line1"
                                    clearable
                                    outlined
                                    hint="Address line 1"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="Address line 2"
                                    v-model="info.line2"
                                    clearable
                                    outlined
                                    hint="Address line 2"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="City"
                                    v-model="info.city"
                                    clearable
                                    outlined
                                    hint="City"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="State"
                                    v-model="info.state"
                                    clearable
                                    outlined
                                    hint="State"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="Zip"
                                    v-model="info.zip"
                                    clearable
                                    outlined
                                    hint="Zip"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10" md="4">
                            <v-text-field
                                    dense
                                    label="Website"
                                    v-model="info.website"
                                    clearable
                                    outlined
                                    hint="Website"
                                    @keyup="setChange()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="5" md="2" class="font-weight-light text-center py-0">
                            <v-btn :height="ibht" outlined>
                                <v-avatar tile :size="ibht-2" @click="activeimage={src:info.logo,name:'Logo',val:'logo'};imagedialog=true">
                                    <img :src="info.logo" />
                                </v-avatar>
                            </v-btn>
                            <div class="font-weight-light text-center">Logo</div>
                        </v-col>
                        <v-col cols="6" sm="5" md="2" class="font-weight-light text-center py-0">
                            <v-btn :height="ibht" outlined>
                                <v-avatar tile :size="ibht-2" @click="activeimage={src:info.small_logo,name:'Small Logo',val:'small_logo'};imagedialog=true">
                                    <img :src="info.small_logo" />
                                </v-avatar>
                            </v-btn>
                            <div class="font-weight-light text-center">Small Logo</div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <BaseBtn @click="cancel()" :disabled="!dirty">
                    <v-icon>{{icons.undo}}</v-icon>
                    <span class="hidden-xs-only">Reset</span>
                </BaseBtn>
                <v-spacer></v-spacer>
                <BaseBtn :loading="loading" :disabled="!(dirty && validinfo)" @click="save()">Save</BaseBtn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="imagedialog" max-width="500">
            <v-card v-if="activeimage">
                <v-card-title>
                    {{activeimage.name}}
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-img :src="activeimage.src" />
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="activeimage=undefined;imagedialog=undefined">
                        <v-icon>{{icons.close}}</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <FileSelect v-if="activeimage.name==='Small Logo'" :selectcount="1" @selectedfiles="setSmallLogo($event)" />
                    <FileSelect v-else :selectcount="1" @selectedfiles="setLogo($event)" />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import BaseBtn from "../BaseBtn";
  import isEqual from 'lodash/isEqual'
  import FileSelect from "../FileSelect";
  export default {
    components: {FileSelect, BaseBtn},
    name: "OrgInfo",
    data() {
      return {
        loading:false,
        dirty:false,
        info:{},
        cellerror:false,
        cellerrormessage:undefined,
        validinfo:true,
        users:false,
        emailverified:false,
        imagedialog: false,
        activeimage: undefined,
        ibht: 70
      }
    },
    computed:{
      ...mapState(['icons','appdata','org']),
      info_unchanged(){
        if(this.org) {
          return this.org.info
        } else{
          return {
            "email": "",
            "fullname": "",
            "logo": "",
            "phone": ""
          }
        }
      }
    },
    watch:{
      org(n){
        if(!n){
          this.rookie = true;
          return
        }
        this.info = Object.assign({},this.$store.state.org.info)
        this.rookie=false
      }
    },
    mounted() {
      // if(!this.$store.state.customer || !this.$store.state.plans || !this.$store.state.products){
      //   this.$router.replace('/account')
      // }
      this.cancel()
      this.$store.dispatch('removeNtfs',{code:'apporg'})
    },
    methods: {
      ...mapActions(['get', 'post']),
      async save(){
        let em = this;
        if(!this.$refs.form.validate())this.dirty=true
        this.loading=true;
        let path
        let orgkey
        if(!this.$store.state.org){
          orgkey = false
          path = 'api/orgs/createv2'
        } else {
          orgkey=this.$store.state.org.partkey,
          path = 'api/orgs/updatev2'
        }
        let body = {
          orgkey:orgkey,
          key:'info',
          value:this.info,
          app:'textappy',
          user:this.$store.state.cognito.user.attributes,
          rookie:true
        }
        let res = await this.post({path:path,body:body})
        this.loading=false
        if(res.error) {
          em.$store.commit('setSnackbar', {
            type: res.error.status,
            msg: res.error.message,
            timeout: 5000
          })
          return
        }
        this.$store.dispatch('putAppOrg',res)
        this.$store.dispatch('removeNtfs',{code:'apporg'})
        this.$store.commit('setSnackbar',{
          type: 'success',
          msg: (this.rookie)?'Thats it! Go add some contacts!':'Organization saved!',
          timeout:5000
        })
        this.setChange()
      },
      cancel(){
        this.info = Object.assign({},this.info_unchanged)
        this.dirty = false
      },
      checkCancel(){
        this.$router.history.go(-1)
      },
      setChange(){
        let a = Object.values(this.info)
        let b = Object.values(this.info_unchanged)
        let s = isEqual(a,b)
        if(this.info.email!==this.info_unchanged.email){
          this.info.emailverified = false
        } else {
          this.info.emailverified = true
        }
        this.dirty = !s
      },
      async verifyEmail(){
        if(this.info.emailverified)return;
        let res = await this.post({path:'api/share/checkverifiedemailsv2',body:{email:this.info.email}})
        if(res.verified) this.$store.commit('setOrg',res.org )
      },
      setLogo(e){
        let l = JSON.parse(JSON.stringify(e))
        let src = l.pop()
        this.info.logo=src
        this.activeimage = this.activeimage={src:src,name:'Logo',val:'logo'};
        this.setChange()
      },
      setSmallLogo(e){
        let l = JSON.parse(JSON.stringify(e))
        let src = l.pop()
        this.info.small_logo=src
        this.activeimage = this.activeimage={src:src,name:'Small Logo',val:'small_logo'};
        this.setChange()
      }
    }
  }
</script>

<style scoped>

</style>